import React from 'react';
import { IAnalytic } from '../../../../types/analytics';

interface ListNavigationProps {
  availableAnalytics: IAnalytic[];
  activePlotAnalytics: string | null
  handleAnalyticsTypeChanged: (analytic: IAnalytic) => void;
  isLoading: boolean
}

const ListNavigation = ({
  availableAnalytics,
  activePlotAnalytics,
  handleAnalyticsTypeChanged,
  isLoading
}: ListNavigationProps) => {
const handleClick = (item: IAnalytic) => {
  if (isLoading) return
  handleAnalyticsTypeChanged(item)
};

const getItemStyles = (item: IAnalytic) => {
  const isActive = item.id === activePlotAnalytics;
  const isDisabled = isLoading ? !isActive : item.disabled;

  return {
    container: {
      padding: '12px 8px',
      transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
      borderRadius: '6px',
      margin: '2px 0',
      cursor: 'pointer',
      color: isDisabled ? 'grey' : '#0099ff',
      fontWeight: isActive ? 'bold' : 'normal',
      backgroundColor: isActive ? 'rgba(0, 153, 255, 0.1)' : 'transparent',
      borderRight: isActive ? '3px solid #0099ff' : 'none',
      transform: isActive ? 'translateX(2px)' : 'none',
      opacity: isDisabled ? 0.6 : 1
    },
    text: {
      fontSize: '13px',
      display: 'block',
      lineHeight: '1.3',
      color: isDisabled ? 'grey' : 'inherit',
      fontWeight: isActive ? 600 : 'normal'
    }
  };
};

return (
  <div style={{display: 'flex', flexDirection: 'column', fontSize: '12px'}}>
    {availableAnalytics.map((item) => {
      const styles = getItemStyles(item)

      return (
        <div
          key={item.id}
          style={styles.container}
          onClick={() => handleClick(item)}
        >
          <span style={styles.text}>
            {item.name}
          </span>
        </div>
      )
    })}
  </div>
  )
}

export default ListNavigation;
